var map = {
	"./android-icon.svg": 2245,
	"./app-img.png": 2246,
	"./app-qr-code-bg.png": 2247,
	"./apple-icon.svg": 2248,
	"./contact-bg.png": 2249,
	"./contact-us-bg.jpg": 2250,
	"./qr-bg.png": 2251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2244;